import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/common/BreadCrumb";
import ReactSelect from "react-select";
import DebounceSearch from "../../../components/common/DebounceSearch";
import { FileterIcon, SortDownArrow } from "../../../assets/svg";
import ReactDatePicker from "react-datepicker";
import Action from "../../../components/common/Action";
import { Badge, InputWithLabel } from "../../../components/micro/input";
import CustomTable from "../../../components/customTable/CustomTable";
import Filterpanel from "./Filterpanel";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import ButtonLoader from "../../../components/loader/ButtonLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTechnicianEarning,
  getTechnicianEarningList,
  updateTechnicianEarningStatus,
} from "../../../redux/technician/slice";
import moment from "moment";
import RippleLoader from "../../../components/loader/RippleLoader";

const Earning = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState("active");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [selectedAction, setSelectedAction] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showRevertModal, setShowRevertModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [currentAmount, setCurrentAmount] = useState(0);
  const [updatedAmount, setUpdatedAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [technicianIdToArchive, setTechnicianIdToArchive] = useState(null);
  const [technicianIdToUnarchive, setTechnicianIdToUnarchive] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const [showAmountConfirmModal, setShowAmountConfirmModal] = useState(false);
  const [technicianIdToDelete, setTechnicianIdToDelete] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [modifiedDate, setModifiedDate] = useState("latest_modified_date");
  const [tempRoles, setTempRoles] = useState(["All"]);
  const [tempPaymentStatus, setTempPaymentStatus] = useState(["All"]);
  const [showAlreadyPaidModal, setShowAlreadyPaidModal] = useState(false);
  const [showAlreadyPaid, setShowAlreadyPaid] = useState("");

  const DateRange =
    dateRange[0] && dateRange[1]
      ? `${moment(dateRange[0]).format("DD/MM/YYYY")} - ${moment(
          dateRange[1]
        ).format("DD/MM/YYYY")}`
      : "";

  //Selector
  const { techniciansEarningList, techniciansEarningListLoading } = useSelector(
    (store) => ({
      techniciansEarningList:
        store?.technicianData?.getTechnicianEarningListStatus?.data,
      techniciansEarningListLoading: store?.technicianData?.loading,
    })
  );

  // Get technician earning list
  useEffect(() => {
    dispatch(
      getTechnicianEarningList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        status: activeTab === "archived" ? "archive" : activeTab,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        date_range: DateRange || "",
        modified_by: modifiedDate,
        role: tempRoles.includes("All") ? [] : tempRoles,
        payment_status: tempPaymentStatus.includes("All")
          ? []
          : tempPaymentStatus,
      })
    );
  }, [
    dispatch,
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    sortBy,
    sortDirection,
    DateRange,
    tempRoles,
    tempPaymentStatus,
    modifiedDate,
  ]);

  // update status
  const updateStatus = (
    id,
    element,
    status,
    isActive,
    madePaymentValue,
    overridePayload = {}
  ) => {
    const payload = {
      ids: element?.id ?? element,
      made_payment: madePaymentValue,
      status: status,
      is_active: isActive,
      amount: element?.amount,
      ...overridePayload,
    };

    dispatch(updateTechnicianEarningStatus({ id: id, data: payload })).then(
      (res) => {
        if (res?.type === "updateTechnicianEarningStatus/fulfilled") {
          dispatch(
            getTechnicianEarningList({
              search: searchValue,
              pageCount: pageCount,
              pageLimit: pageLimit,
              status: activeTab === "archived" ? "archive" : activeTab,
              sort_by: sortBy,
              sort_direction: sortDirection === "asc" ? "asc" : "desc",
              date_range: DateRange || "",
              role: tempRoles.includes("All") ? [] : tempRoles,
              payment_status: tempPaymentStatus.includes("All")
                ? []
                : tempPaymentStatus,
            })
          );
          setSelectedAction("");
          setSelectedRows([]);
          setIsSelectAll(false);
        }
      }
    );
  };
  // payment status
  const updatePaymentStatus = (element, madePaymentValue) => {
    dispatch(
      updateTechnicianEarningStatus({
        id: element?.id,
        data: {
          ids: element?.id ?? element,
          made_payment: madePaymentValue,
        },
      })
    ).then((res) => {
      if (res.type === "updateTechnicianEarningStatus/fulfilled") {
        dispatch(
          getTechnicianEarningList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            date_range: DateRange || "",
            role: tempRoles.includes("All") ? [] : tempRoles,
            payment_status: tempPaymentStatus.includes("All")
              ? []
              : tempPaymentStatus,
          })
        );
        setSelectedAction("");
        setSelectedRows([]);
        setIsSelectAll(false);
      }
    });
  };

  const handleConfirmEditAmount = () => {
    if (!updatedAmount) {
      setValidationError("Amount is required.");
      return;
    }

    const payload = {
      ids: [selectedTechnician?.id],
      amount: updatedAmount,
    };

    dispatch(
      updateTechnicianEarningStatus({
        id: selectedTechnician?.id,
        data: payload,
      })
    ).then((res) => {
      if (res?.type === "updateTechnicianEarningStatus/fulfilled") {
        dispatch(
          getTechnicianEarningList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            date_range: DateRange || "",
            role: tempRoles.includes("All") ? [] : tempRoles,
            payment_status: tempPaymentStatus.includes("All")
              ? []
              : tempPaymentStatus,
          })
        );
        setSelectedAction("");
        setOpenEditModal(false);
        setUpdatedAmount("");
        setSelectedRows([]);
        setIsSelectAll(false);
      }
    });
  };

  // Archive data
  const handleArchive = () => {
    if (technicianIdToArchive) {
      updateStatus(
        technicianIdToArchive.id,
        technicianIdToArchive,
        "archive",
        false
      );
    }
    setSelectedAction("");
    setSelectedRows([]);
    setIsSelectAll(false);
    setShowConfirmationModal(false);
  };

  //  unarchive
  const handleUnarchive = () => {
    if (technicianIdToUnarchive) {
      updateStatus(
        technicianIdToUnarchive.id,
        technicianIdToUnarchive,
        "active",
        true
      );
    }
    setSelectedAction("");
    setSelectedRows([]);
    setIsSelectAll(false);
    setIsModalOpen(false);
  };

  // Delete Technician earning
  const deleteTechnicianId = () => {
    setIsLoading(true);
    if (!technicianIdToDelete) return;
    dispatch(deleteTechnicianEarning(technicianIdToDelete)).then((res) => {
      if (res.type === "deleteTechnicianEarning/fulfilled") {
        dispatch(
          getTechnicianEarningList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            date_range: DateRange || "",
            role: tempRoles.includes("All") ? [] : tempRoles,
            payment_status: tempPaymentStatus.includes("All")
              ? []
              : tempPaymentStatus,
          })
        );
      }
      setSelectedAction("");
      setSelectedRows([]);
      setIsSelectAll(false);
      setIsLoading(false);
      setConfirmDelete(false);
    });
  };

  const bulkOptions = () => {
    return activeTab === "active"
      ? [
          { value: "payment", label: "Made Payment" },
          { value: "unpaid", label: "Revert to Unpaid" },
          { value: "archive", label: "Archive" },
        ]
      : [
          { value: "unarchive", label: "Unarchive" },
          { value: "delete", label: "Delete" },
        ];
  };

  const handleBulkAction = (e) => {
    setSelectedAction(e);

    const selectedData = techniciansEarningList?.data?.data?.filter((item) =>
      selectedRows.includes(item.id)
    );

    if (!selectedData || selectedData.length === 0) return;

    if (e.value === "payment") {
      const unpaidItems = selectedData.filter(
        (item) => item.payment_status !== "paid"
      );
      const alreadyPaid = selectedData.filter(
        (item) => item.payment_status === "paid"
      );

      if (unpaidItems.length) {
        const unpaidIds = unpaidItems.map((item) => item.id);
        updatePaymentStatus(unpaidIds, 1);
      }

      if (alreadyPaid.length) {
        setShowAlreadyPaid("paid");
        setShowAlreadyPaidModal(true);
      }
    }

    if (e.value === "unpaid") {
      const unpaidItems = selectedData.filter(
        (item) => item.payment_status !== "unpaid"
      );
      const alreadyUnpaid = selectedData.filter(
        (item) => item.payment_status === "unpaid"
      );

      if (unpaidItems.length) {
        const unpaidIds = unpaidItems.map((item) => item.id);
        updatePaymentStatus(unpaidIds, 0);
      }

      if (alreadyUnpaid.length) {
        setShowAlreadyPaid("unpaid");
        setShowAlreadyPaidModal(true);
      }
    }

    if (e.value === "archive") {
      const ids = selectedData.map((item) => item.id);
      setShowConfirmationModal(true);
      setTechnicianIdToArchive(ids);
    }

    if (e.value === "unarchive") {
      const ids = selectedData.map((item) => item.id);
      setIsModalOpen(true);
      setTechnicianIdToUnarchive(ids);
    }

    if (e.value === "delete") {
      const ids = selectedData.map((item) => item.id);

      setConfirmDelete(true);
      setTechnicianIdToDelete(ids);
    }
  };

  const handleRowSelection = (id, isChecked) => {
    setSelectedRows((prevSelected) => {
      const updatedSelection = new Set(prevSelected);

      if (isChecked) {
        updatedSelection.add(id);
      } else {
        updatedSelection.delete(id);
      }

      const totalItems = techniciansEarningList?.data?.data?.length || 0;
      setIsSelectAll(updatedSelection.size === totalItems);

      return Array.from(updatedSelection);
    });
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsSelectAll(checked);

    const list = techniciansEarningList?.data?.data || [];

    if (checked) {
      setSelectedRows(list.map((item) => item.id));
    } else {
      setSelectedRows([]);
    }
  };

  const selectedTechnicians =
    techniciansEarningList?.data?.data?.filter((tech) =>
      selectedRows.includes(tech.id)
    ) || [];

  const selectedCount = selectedTechnicians.length;

  const selectedTotalAmount = selectedTechnicians.reduce(
    (total, tech) => total + Number(tech.amount || 0),
    0
  );

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  px-4  text-mgrey text-start"
      >
        <div className="flex items-center">
          <div className="flex items-center">
            <input
              type="checkbox"
              className="w-4 h-4 mr-2 accent-themeBtn"
              checked={isSelectAll}
              onChange={handleSelectAll}
            />

            <span>ID.</span>
          </div>
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("technician_name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Technician Name</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "technician_name"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("role");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Role</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "role" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        Invoice No
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        Service Report
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        Earning Amount
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("payment_date");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Payment Date </span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "payment_date"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("payment_status");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span> Payment Status</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "payment_status"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className=" font-Proxima text-sm font-normal py-4  text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("last_modified_date ");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span> Last Modified Date</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "last_modified_date "
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4  text-mgrey text-start">
        Action
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {(techniciansEarningList?.data?.data || []).map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-4 py-3">
            <div className="flex items-center">
              <input
                type="checkbox"
                className="w-4 h-4 mr-2 accent-themeBtn"
                onChange={(e) =>
                  handleRowSelection(element.id, e.target.checked)
                }
                checked={selectedRows.includes(element.id)}
              />

              {element.unique_id ?? "-"}
            </div>
          </td>
          <td className="px-5 py-3 truncate">
            {element?.technician?.full_name ?? "-"}
          </td>
          <td className="px-5 py-3 truncate">{element?.role ?? "-"}</td>
          <td className="px-5 py-3">
            <button className="text-themeBtn border-b border-b-lightOrangeTheme w-14 text-center h-4">
              {element?.sales?.unique_id ?? "-"}
            </button>
          </td>
          <td className="px-5 py-3">
            <button className="text-themeBtn border-b w-14 border-b-lightOrangeTheme text-center h-4">
              {element?.service_report?.unique_id ?? "-"}
            </button>
          </td>
          <td className="px-5 py-3">
            {isNaN(parseFloat(element?.amount))
              ? "-"
              : `$${parseFloat(element.amount)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
          </td>

          <td className="px-5 py-3">
            {element?.payment_date
              ? new Date(element.payment_date).toLocaleDateString("en-GB")
              : "-"}
          </td>
          <td className="px-5 py-3">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  element?.payment_status === "unpaid"
                    ? "bg-red text-white"
                    : element?.payment_status === "paid"
                    ? "text-white bg-bgGreen"
                    : ""
                }`}
                value={
                  element?.payment_status === "unpaid"
                    ? "Unpaid"
                    : element?.payment_status === "paid"
                    ? "Paid"
                    : "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">
            {element?.last_modified_date
              ? new Date(element.last_modified_date).toLocaleDateString("en-GB")
              : "-"}
          </td>
          <td className="flex px-5 py-3">
            {activeTab === "active" ? (
              <Action
                optionList={
                  <>
                    {element.payment_status === "unpaid" ? (
                      <>
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                          onClick={() => {
                            setSelectedTechnician(element);
                            setShowPaymentModal(true);
                          }}
                        >
                          Made Payment
                        </li>
                        <li
                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                          onClick={() => {
                            setOpenEditModal(true);
                            setSelectedTechnician(element);
                            setCurrentAmount(Number(element?.amount));
                          }}
                        >
                          Edit Earning
                        </li>
                      </>
                    ) : (
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setSelectedTechnician(element);
                          setShowRevertModal(true);
                        }}
                      >
                        Revert to Unpaid
                      </li>
                    )}
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setShowConfirmationModal(true);
                        setTechnicianIdToArchive([element?.id]);
                      }}
                    >
                      Archive
                    </li>
                  </>
                }
              />
            ) : (
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setIsModalOpen(true);
                        setTechnicianIdToUnarchive([element?.id]);
                      }}
                    >
                      Unarchive
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmDelete(true);
                        setTechnicianIdToDelete(element?.id);
                      }}
                    >
                      Delete
                    </li>
                  </>
                }
              />
            )}
          </td>
        </tr>
      ))}
    </>
  );

  const handleApplyFilter = () => {
    // Get the selected filter values
    const selectedModifiedDate = modifiedDate;
    const selectedRoles = tempRoles;
    const selectedPaymentStatus = tempPaymentStatus;

    dispatch(
      getTechnicianEarningList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        status: activeTab === "archived" ? "archive" : activeTab,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        date_range: DateRange || "",
        modified_by: selectedModifiedDate,
        role: selectedRoles.includes("All") ? [] : selectedRoles,
        payment_status: selectedPaymentStatus.includes("All")
          ? []
          : selectedPaymentStatus,
      })
    );
    setShowFilter(false);
  };

  return (
    <>
      <div className="space-y-5">
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Technicians Earning
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Technician Earning Log"}
              breadCrumbParent2={"Earning"}
              classes=""
            />
          </div>
        </div>

        <div className="flex  justify-between py-4">
          {/* Amount summary */}
          <div className="flex gap-4 rounded-xl shadow-md px-6 py-4 w-1/2 bg-background_grey">
            <div className="w-1/2 border-r border-stepGray">
              <p className="text-sm text-themeBtn font-normal">
                Total Paid Amount:
              </p>
              <p className="text-xs text-textSecondary">
                Total Count: {techniciansEarningList?.data?.total_paid_count}
              </p>
              <p className="text-3xl mt-3 text-primaryBlack font-Montserrat">
                $
                {techniciansEarningList?.data?.total_paid_amount != null
                  ? (+techniciansEarningList.data
                      .total_paid_amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })
                  : "0.00"}
              </p>
            </div>
            <div className="text-left w-1/2">
              <p className="text-sm text-themeBtn font-normal">
                Total Selected Amount:
              </p>
              <p className="text-xs text-textSecondary">
                Total Count: {selectedCount}
              </p>
              <p className="text-3xl mt-3 text-primaryBlack font-Montserrat">
                $
                {selectedTotalAmount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
          </div>
          <div className="flex gap-4 justify-end items-end w-1/4">
            <div className="flex justify-end items-end">
              {["active", "archived"].map((tab, index) => (
                <button
                  key={tab}
                  className={`transition uppercase duration-300 text-sm font-normal font-Proxima ${
                    index === 0 ? "!rounded-l !rounded-r-none" : ""
                  } ${index === 1 ? "!rounded-r !rounded-l-none" : ""} ${
                    activeTab === tab
                      ? "bg-themeBtn text-white flex items-center justify-center px-4 py-1.5 rounded"
                      : "bg-disabletheme text-white flex items-center justify-center px-4 py-1.5 rounded"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div>
              <div
                className="bg-primaryOrange p-2 rounded cursor-pointer"
                onClick={() => setShowFilter(true)}
              >
                <FileterIcon />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 w-full">
          {/* Bulk Action */}
          <div className="w-full sm:w-[200px] md:w-[220px] min-w-[160px]">
            <ReactSelect
              className="w-full text-black p-0 font-Proxima"
              id="bulkaction"
              placeholder="Bulk Action"
              options={bulkOptions(selectedRows)}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.label}
              isDisabled={selectedRows?.length === 0}
              value={selectedAction}
              onChange={handleBulkAction}
              styles={{
                control: (base) => ({
                  ...base,
                  border: `1px solid #0000003B`,
                  borderColor: selectedAction ? "#F15B29" : "#0000003B",
                  borderRadius: "0.3rem",
                  boxShadow: "none",
                  "&:hover": { border: "1px solid #0000003B" },
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? "#F15B29" : "white",
                  "&:active": {
                    backgroundColor: state.isSelected
                      ? "#F15B29"
                      : "rgba(0, 0, 0, 0.04)",
                  },
                }),
              }}
            />
          </div>

          {/* Date Range */}
          <div className="w-full sm:w-[200px] md:w-[220px] min-w-[160px]">
            <div className="text-black border border-borderTheme/80 flex justify-between relative rounded w-full px-2 py-[6px] items-center transition duration-300 ease-in-out">
              <ReactDatePicker
                selected={dateRange[0]}
                onChange={(dates) => setDateRange(dates)}
                selectsRange
                isClearable
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="Date Range"
                className="w-full"
              />
            </div>
          </div>

          {/* Search */}
          <div className="w-full sm:flex-1 min-w-[180px]">
            <DebounceSearch
              className="w-full"
              search={searchValue}
              handleChange={setSearchValue}
              placeholder="Search..."
            />
          </div>
        </div>

        {techniciansEarningListLoading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 ">
            <CustomTable
              overflowVisibleLg={true}
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={techniciansEarningList?.data}
              // loader
              loading={false}
              showPagination={true}
              //show pageLimit
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              //paginationData
              total={techniciansEarningList?.data?.total}
              current={pageCount}
              paginationData={(crPage) => setPageCount(crPage)}
              lastPage={Math.ceil(
                techniciansEarningList?.data?.total / pageLimit
              )}
            />
          </div>
        )}
      </div>
      {/* Filter Side Panel */}
      <Filterpanel
        show={showFilter}
        onClose={() => setShowFilter(false)}
        onApply={handleApplyFilter}
        roles={tempRoles}
        modifiedDate={modifiedDate}
        setModifiedDate={setModifiedDate}
        setRoles={setTempRoles}
        paymentStatus={tempPaymentStatus}
        setPaymentStatus={setTempPaymentStatus}
      />

      {showPaymentModal && selectedTechnician && (
        <ConfirmationModel
          confirmText={"You Had Made Payment"}
          onClose={() => {
            setShowPaymentModal(false);
            setSelectedTechnician(null);
          }}
          onConfirm={() => {
            updatePaymentStatus([selectedTechnician?.id], 1);
            setShowPaymentModal(false);
          }}
        />
      )}

      {showRevertModal && selectedTechnician && (
        <ConfirmationModel
          confirmText={"Revert to Unpaid"}
          onClose={() => {
            setShowRevertModal(false);
            setSelectedTechnician(null);
          }}
          onConfirm={() => {
            updatePaymentStatus([selectedTechnician?.id], 0);
            setShowRevertModal(false);
          }}
        />
      )}

      {showConfirmationModal && (
        <div>
          <ConfirmationModel
            confirmText={"Archive"}
            onClose={() => {
              setShowConfirmationModal(false);
            }}
            onConfirm={handleArchive}
            isLoading={isLoading}
          />
        </div>
      )}
      {isModalOpen && (
        <div>
          <ConfirmationModel
            confirmText={"unarchive"}
            onClose={() => {
              setIsModalOpen(false);
            }}
            onConfirm={handleUnarchive}
            isLoading={isLoading}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={deleteTechnicianId}
            // isLoading={isLoading}
          />
        </div>
      )}
      {openEditModal && (
        <div className="model">
          <div className="bg-white flex flex-col drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative">
            <h2 className="text-xl font-base text-center mb-4 font-Montserrat">
              Edit Earning
            </h2>

            <div className="mb-4">
              <p className="text-sm text-gray-600 font-Proxima">
                Current Amount:
              </p>
              <p className="text-lg font-medium  font-Proxima">
                ${currentAmount.toFixed(2)}
              </p>
            </div>
            <InputWithLabel
              className={
                "text-black  border hover:border-themeBtn `border border-borderTheme/80 focus-within:border-themeBtn"
              }
              idFromName="amount"
              label="Updated Amount"
              type="number"
              onChange={(e) => setUpdatedAmount(e.target.value)}
              value={updatedAmount}
            />
            {validationError && (
              <p className="text-red text-xs mt-1">{validationError}</p>
            )}
            <div className="flex justify-center gap-2 pt-3">
              <button
                onClick={() => setOpenEditModal(false)}
                type="button"
                className="text-themeBtn flex items-center uppercase font-Proxima text-[15px]  justify-center px-6 py-1.5 rounded border border-themeBtn w-full"
              >
                <span>Cancel</span>
              </button>
              <button
                type="submit"
                className={`flex items-center justify-center px-6 py-1.5 rounded font-normal font-Proxima text-[15px] uppercase shadow-[4px_4px_10px_rgba(0,0,0,0.2)] w-full ${
                  isLoading
                    ? "bg-disableThemeBtn "
                    : "border-2 border-themeBtn  rounded text-white bg-themeBtn"
                }`}
                disabled={isLoading}
                onClick={() => setShowAmountConfirmModal(true)}
              >
                {isLoading ? (
                  <ButtonLoader removeTheme={true} />
                ) : (
                  <span className="font-normal">Confirm</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {showAmountConfirmModal && (
        <ConfirmationModel
          confirmText="Edit Earning"
          onClose={() => setShowAmountConfirmModal(false)}
          onConfirm={() => {
            setShowAmountConfirmModal(false);
            setOpenEditModal(false);
            handleConfirmEditAmount();
          }}
        />
      )}
      {showAlreadyPaidModal && (
        <div className="model" onClick={() => setShowAlreadyPaidModal(false)}>
          <div
            className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="font-Montserrat mb-1 text-center text-primaryBlack font-medium text-xl">
              {`Can not mark as ${
                showAlreadyPaid === "paid" ? "Paid" : "Unpaid"
              } to already ${
                showAlreadyPaid === "paid" ? "Paid" : "Unpaid"
              } entires, please make changes to the selections of the entires`}
            </h2>
            <div className="flex justify-center gap-2 pt-3 w-full">
              <button
                type="button"
                className="text-themeBtn flex items-center uppercase font-Proxima text-[15px] justify-center px-6 py-1.5 rounded border border-themeBtn"
                onClick={() => setShowAlreadyPaidModal(false)}
              >
                close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Earning;
